
import { Component, Inject, Provide, Vue } from 'vue-property-decorator';
import State from './state';

@Component
export default class ZoomControls extends Vue {
  @Inject()
  readonly state!: State;

  fitToContainer(): void {
    this.state.canvasRef?.fitToContainer();
  }

  zoomIn(): void {
    this.state.canvasRef?.zoomIn();
  }

  zoomOut(): void {
    this.state.canvasRef?.zoomOut();
  }
}
